import { useQuery } from "@tanstack/react-query";
import { getSKUMovementEnquiry } from "services/data.report.service";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { stockInventoryEnquiryColumns } from "./columns";
import { useState, useEffect } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { getStockInventoryEnquiry, exportStockInventoryAllCustomer } from "services/data.report.service";
import { CSVLink } from "react-csv";
import { useTeamValue } from "providers/TeamContext";
import { LoadingDialog } from "ui-components/Alert";
import { Success, Error, Error_ } from "ui-components/Alert";
import { ExportButton } from "ui-components/Button";
import { EmailButton } from "ui-components/Button";
import { SelectFields } from "ui-components/Form";
import { Grid } from "@mui/material";
import { getCustomerOptions } from "services/data.internal.service";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import useFileDownloadHook from "hooks/useFileDownloadHook";
import dayjs from "dayjs";
import { ExportDialog } from "ui-components/Alert";

function StockInventoryEnquiry() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode, customerOpt } = useCustomerValue();
  const { isDownloading, downloadCsv } = useCsvDownloadHook();
  const { downloadFile, isDownloading: isExporting, error: exportError } = useFileDownloadHook();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const exportPermission =
    allowAll ||
    (Boolean(permissions["Stock Inventory_Report"]) &&
      permissions["Stock Inventory_Report"].findIndex((b) => b === "export") !== -1);
  const handleFilterRowsChange = (filteredData) => {
    setFilteredData(filteredData);
  };
  const [alert, setAlert] = useState(null);

  const [customers, setCustomers] = useState([]);
  const isAllCustomer = customers.includes("ALL CUSTOMER");

  const [customerOptions, setCustomerOptions] = useState([]);

  useEffect(() => {
    if (exportError) {
      setAlert(<Error_ content={exportError.message} onChange={setAlert} />);
    }
  }, [exportError]);

  const onExportAllCustomer = () => {
    const filename = `ALLCUSTOMER_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_StockInventory.xlsx`;
    downloadFile(() => exportStockInventoryAllCustomer(), filename);
  };

  const { refetch, isFetching } = useQuery({
    queryKey: ["stock-inventory-enquiry", { customers }],
    queryFn: () => getStockInventoryEnquiry({ customerCode, customers }),
    enabled: Boolean(customerCode) && Boolean(customers.length) && !isAllCustomer,
    onSuccess: (data) => {
      setData(data.data.data);
      setFilteredData(data.data.data);
    },
    onError: () => {},
  });

  useQuery({
    queryKey: ["customer-options", { customerCode }],
    queryFn: () => getCustomerOptions(),
    onSuccess: (data) => {
      const activeCust = customerOpt.filter((x) => data.data.some((y) => y === x));
      setCustomerOptions(activeCust);
      setCustomers([customerCode]);
    },
    onError: () => {},
  });

  const onSuccess = (data) => {
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const onError = (data) => {
    setAlert(<Error data={data} onChange={setAlert} />);
  };
  const totals = filteredData.reduce(
    (acc, item) => {
      acc.totalInventory += parseInt(item.inventoryQty || 0);
      acc.totalHold += parseInt(item.holdQty || 0);
      acc.totalAllocated += parseInt(item.allocatedQty || 0);
      acc.totalCommitted += parseInt(item.committedQty || 0);
      acc.totalBalance += parseInt(item.balanceQty || 0);
      return acc;
    },
    { totalInventory: 0, totalHold: 0, totalAllocated: 0, totalCommitted: 0, totalBalance: 0 }
  );

  const { totalInventory, totalHold, totalAllocated, totalCommitted, totalBalance } = totals;
  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {(isDownloading || isExporting) && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}
      <TableCard sx={{ my: 3 }}>
        {/* <MDBox display="flex" justifyContent="flex-end" margin="10px">
          <MDButton variant="gradient" color="info" disabled={!exportPermission}>
            <CSVLink style={{ color: "white" }} filename={`StockInventory_`} data={filteredData}>
              export
            </CSVLink>
          </MDButton>
        </MDBox> */}

        <MDBox margin="1rem 1rem 0 1rem">
          <Grid container spacing={3}>
            <Grid item xs={3}>
              {Boolean(customerOptions) && Boolean(customerOptions.length) && (
                <SelectFields
                  field={{
                    name: "",
                    label: "Customers",
                    value: customers,
                    errors: {},
                    multiple: true,
                  }}
                  options={["ALL CUSTOMER", ...customerOptions]}
                  onChange={(e, v) => {
                    if (v.includes("ALL CUSTOMER")) {
                      setCustomers(["ALL CUSTOMER"]);
                      setData([]);
                      setFilteredData([]);
                    } else {
                      setCustomers(v);
                    }
                  }}
                />
              )}
            </Grid>
            <Grid item xs={4}>
              {isAllCustomer ? (
                <MDButton
                  variant="gradient"
                  color="info"
                  disabled={!exportPermission}
                  onClick={() => {
                    onExportAllCustomer();
                  }}
                >
                  export
                </MDButton>
              ) : (
                <MDButton
                  sx={{ marginLeft: "1rem" }}
                  variant="gradient"
                  color="info"
                  disabled={!exportPermission}
                  onClick={() => {
                    const filename = `${customers.join(", ")}_${dayjs(new Date()).format(
                      "YYYYMMDD-HHmm"
                    )}_StockInventory`;
                    downloadCsv(filename, filteredData);
                  }}
                >
                  export
                </MDButton>
              )}
            </Grid>
            {!isAllCustomer && (
              <Grid item xs={5}>
                <EmailButton
                  variant="gradient"
                  color="info"
                  filename={`${customers.join(", ")}_${dayjs(new Date()).format(
                    "YYYYMMDD-HHmm"
                  )}_StockInventory`}
                  fileData={filteredData}
                  onSuccess={onSuccess}
                  onError={onError}
                  customerCode={customerCode}
                />
              </Grid>
            )}
          </Grid>
        </MDBox>
        {!isAllCustomer && (
        <BasicTable
          data={data}
          columns={stockInventoryEnquiryColumns}
          onFilterRowsChange={handleFilterRowsChange}
          caption={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "24px",
                padding: "12px 16px",
                backgroundColor: "#f8f9fa",
                //borderRadius: "8px",
                fontSize: "14px",
                color: "#666",
                //marginBottom: "1rem",
              }}
            >
              <div style={{ display: "flex", gap: "8px" }}>
                <span>Total Inventory:</span>
                <strong style={{ color: "#111" }}>{totalInventory.toLocaleString()}</strong>
              </div>
              <div style={{ width: "1px", height: "14px", backgroundColor: "#ddd" }} />

              <div style={{ display: "flex", gap: "8px" }}>
                <span>Total Hold:</span>
                <strong style={{ color: "#faad14" }}>{totalHold.toLocaleString()}</strong>
              </div>
              <div style={{ width: "1px", height: "14px", backgroundColor: "#ddd" }} />

              <div style={{ display: "flex", gap: "8px" }}>
                <span>Total Committed:</span>
                <strong style={{ color: "#722ed1" }}>{totalCommitted.toLocaleString()}</strong>
              </div>
              <div style={{ width: "1px", height: "14px", backgroundColor: "#ddd" }} />

              <div style={{ display: "flex", gap: "8px" }}>
                <span>Total Allocated:</span>
                <strong style={{ color: "#1890ff" }}>{totalAllocated.toLocaleString()}</strong>
              </div>
              <div style={{ width: "1px", height: "14px", backgroundColor: "#ddd" }} />

              <div style={{ display: "flex", gap: "8px" }}>
                <span>Total Balance:</span>
                <strong style={{ color: "#52c41a" }}>{totalBalance.toLocaleString()}</strong>
              </div>
            </div>
          }
        />
        )}
      </TableCard>
    </ListLayout>
  );
}

export default StockInventoryEnquiry;
